<script setup>
import { RouterLink } from 'vue-router'
import { ROUTES } from '../../core/config/constants.js'
</script>

<template>
  <div class="document-page">
    <!-- Header -->
    <header class="document-header">
      <div class="header-content">
        <RouterLink :to="{ name: ROUTES.HOME }" class="back-link">
          <svg
            viewBox="0 0 24 24"
            width="20"
            height="20"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path d="M5 12H19M12 5l7 7-7 7" />
          </svg>
          <span>חזרה</span>
        </RouterLink>
        <RouterLink :to="{ name: ROUTES.HOME }" class="logo-wrapper">
          <img src="@/assets/logo/logo_76.png" alt="GoFood" class="logo-img" />
          <span class="logo-text">GoFood</span>
        </RouterLink>
      </div>
    </header>

    <!-- Content -->
    <main class="document-main">
      <article class="document-content">
        <h1>מדיניות פרטיות – מערכת סחר B2B (GoFood)</h1>

        <p>
          רוסמן לוגיסטיקה בע״מ (להלן: <strong>"החברה"</strong>, <strong>"רוסמן"</strong>) מכבדת את
          פרטיות המשתמשים ופועלת להגנה על מידע אישי בהתאם לדיני מדינת ישראל, לרבות חוק הגנת הפרטיות,
          התשמ״א-1981, ותקנות הגנת הפרטיות (אבטחת מידע), התשע״ז-2017, כפי שיעודכנו מעת לעת.
        </p>

        <p>
          מדיניות פרטיות זו חלה על כל שימוש באתר, באפליקציה ובממשקי הזמנה דיגיטליים של החברה (כולם
          יחד: <strong>"המערכת"</strong>).
        </p>

        <p>
          <strong
            >הרשמה למערכת ו/או פתיחת חשבון ו/או שימוש בפועל במערכת מהווים אישור והסכמה למדיניות
            פרטיות זו</strong
          >, כמפורט להלן. אם אינך מסכים למדיניות זו – אין להשתמש במערכת.
        </p>

        <p class="note">
          המערכת מיועדת לשימוש <strong>עסקי (B2B)</strong> בלבד. החברה אינה מתכוונת לאסוף ביודעין
          מידע אישי מקטינים.
        </p>

        <h2>1. הגדרות</h2>
        <p>
          1.1. <strong>"מידע אישי"</strong> – מידע על אדם מזוהה או הניתן לזיהוי, לרבות פרטי קשר,
          תפקיד, פרטי התחברות, היסטוריית פעילות וכד׳.
        </p>
        <p>
          1.2. <strong>"לקוח"</strong> – גוף עסקי (תאגיד/עוסק מורשה/שותפות/עמותה/גוף עסקי אחר)
          המשתמש במערכת לצרכים עסקיים.
        </p>
        <p>1.3. <strong>"משתמש מורשה"</strong> – אדם מטעם הלקוח שהוסמך לבצע פעולות במערכת.</p>

        <h2>2. סוגי מידע שאנו אוספים</h2>
        <p>2.1. <strong>מידע שנמסר על ידך/על ידי הלקוח</strong> בעת הרשמה או ניהול חשבון, כגון:</p>
        <ul>
          <li>
            שם פרטי ושם משפחה, תפקיד/מחלקה, שם חברה/לקוח, מספר ח.פ./עוסק (ככל שנדרש), כתובת
            עסק/סניף, כתובות אספקה.
          </li>
          <li>פרטי התקשרות: טלפון, דוא״ל, ופרטי אנשי קשר נוספים מטעם הלקוח.</li>
          <li>פרטי התחברות והרשאות משתמשים (כולל תיעוד פעולות ניהול הרשאות).</li>
        </ul>

        <p>2.2. <strong>מידע הנאסף במהלך השימוש במערכת</strong>:</p>
        <ul>
          <li>
            היסטוריית הזמנות/רכישות/סלים/ביצועי הזמנה, משלוחים, מסמכי חיוב/זיכוי, פניות שירות.
          </li>
          <li>
            תיעוד תפעולי ואבטחתי (לוגים): פעולות במערכת, זמן/תאריך, זיהוי משתמש, כתובת IP, מזהי
            מכשיר/דפדפן, שגיאות ותקלות.
          </li>
        </ul>

        <p>2.3. <strong>מידע טכני/סטטיסטי</strong>:</p>
        <ul>
          <li>
            נתוני גלישה ושימוש (כגון דפים שנצפו, משך שימוש, אינטראקציות), לרבות באמצעות Cookies וכלי
            אנליטיקה.
          </li>
        </ul>

        <p>2.4. <strong>פרטי תשלום</strong>:</p>
        <ul>
          <li>
            ככל שהמערכת מאפשרת תשלום בכרטיס/אמצעי תשלום – נתוני סליקה מעובדים בדרך כלל באמצעות ספקי
            סליקה. החברה אינה שומרת מספר כרטיס מלא ו/או נתוני אימות מלאים, אלא אם הדבר נדרש ובמידה
            המותרת בדין ובסטנדרטים מקובלים. ייתכן שיישמרו מזהים חלקיים/טכניים לצרכי תיעוד, התאמות
            ותפעול (כגון 4 ספרות אחרונות או אסימון/Token), בהתאם למימוש בפועל.
          </li>
        </ul>

        <p>
          2.5. אינך מחויב לפי חוק למסור מידע אישי, אולם ללא מסירת נתונים מסוימים (שדות חובה) לא ניתן
          יהיה להקים חשבון, להתחבר למערכת או לבצע פעולות מסוימות.
        </p>

        <h2>3. מטרות השימוש במידע</h2>
        <p>החברה משתמשת במידע אישי למטרות הבאות:</p>
        <p>
          3.1. <strong>תפעול ומתן השירות</strong>: הקמת חשבון לקוח, ניהול משתמשים והרשאות, ביצוע
          הזמנות, ליקוט/משלוח, הנהלת חשבונות, מסמכי חיוב/זיכוי, תמיכה ושירות לקוחות.
        </p>
        <p>
          3.2. <strong>אבטחת מידע ומניעת הונאות</strong>: אימות זהות, איתור פעילות חריגה, הגנה מפני
          תקיפות, ניהול הרשאות ובקרות.
        </p>
        <p>
          3.3. <strong>שיפור השירות וחוויית שימוש</strong>: ניתוח שימוש, מדידה, תחזוקה, איתור תקלות,
          פיתוח ושדרוג פונקציות.
        </p>
        <p>
          3.4. <strong>ציות לדין והגנה משפטית</strong>: עמידה בחובות חוקיות, טיפול בבקשות רשויות,
          ניהול מחלוקות, אכיפת תנאי שימוש/הסכמים.
        </p>

        <h2>4. דיוור, חומרים פרסומיים והודעות תפעוליות</h2>
        <p>4.1. החברה עשויה לשלוח אליך/אל משתמשים מורשים:</p>
        <ul>
          <li>
            <strong>הודעות תפעוליות ושירותיות</strong> (שאינן "דבר פרסומת") כגון: אישורי הזמנה,
            עדכוני אספקה, הודעות מערכת, התראות אבטחה, איפוס סיסמה, מסמכי חיוב/זיכוי, פניות שירות
            וכד׳.
          </li>
          <li>
            <strong>דברי פרסומת/תוכן שיווקי</strong> (מבצעים, עדכונים מסחריים, הצעות, תוכן שיווקי).
          </li>
        </ul>

        <p>
          4.2.
          <strong
            >מובהר כי עצם ההסכמה למדיניות פרטיות זו ו/או עצם ההרשמה למערכת אינם מהווים כשלעצמם הסכמה
            מפורשת לקבלת דברי פרסומת.</strong
          >
        </p>
        <p>דברי פרסומת יישלחו רק:</p>
        <ul>
          <li>
            לאחר קבלת <strong>הסכמה מפורשת, נפרדת, אקטיבית ומתועדת</strong> של הנמען (למשל באמצעות
            תיבת סימון ייעודית שאינה מסומנת כברירת מחדל); או
          </li>
          <li>בהתקיים חריג המותר לפי דין (ככל שרלוונטי ובכפוף לתנאים הקבועים בדין).</li>
        </ul>

        <p>
          4.3. בכל דבר פרסומת תופיע אפשרות <strong>הסרה/ביטול הסכמה</strong> פשוטה וברורה. בקשת הסרה
          תכובד בהתאם לדין ובתוך זמן סביר.
        </p>
        <p>
          4.4. גם לאחר הסרה מדיוור שיווקי, החברה רשאית להמשיך לשלוח
          <strong>הודעות תפעוליות/שירותיות</strong> הנדרשות לתפעול החשבון והשירות.
        </p>

        <h2>5. מסירת מידע לצדדים שלישיים</h2>
        <p>
          5.1. החברה עשויה להעביר מידע אישי לספקים ונותני שירות הפועלים מטעמה ולפי הנחיותיה, ככל
          הנדרש למתן השירות, כגון:
        </p>
        <ul>
          <li>ספקי תשתיות מחשוב/אחסון/גיבוי/אבטחה;</li>
          <li>ספקי סליקה ותשלומים;</li>
          <li>ספקי שילוח/לוגיסטיקה;</li>
          <li>ספקי אנליטיקה, ניטור תקלות, ומערכות דיוור/מסרים;</li>
          <li>יועצים מקצועיים (משפטיים/חשבונאיים) לפי צורך.</li>
        </ul>

        <p>
          5.2. ספקים אלו מחויבים לשמור על סודיות ועל אבטחת מידע, ולהשתמש במידע רק לצורך אספקת
          השירותים לחברה.
        </p>

        <p>5.3. החברה רשאית להעביר מידע במקרים הבאים:</p>
        <ul>
          <li>אם הדבר נדרש לפי דין, צו שיפוטי או דרישת רשות מוסמכת;</li>
          <li>
            לצורך הגנה על זכויות החברה, אכיפת הסכמים/תנאי שימוש, מניעת תרמית/הונאה, טיפול במחלוקות;
          </li>
          <li>
            במסגרת שינוי ארגוני (כגון מיזוג/רכישה/העברת פעילות), בכפוף לדין ולהתחייבויות סודיות
            הולמות.
          </li>
        </ul>

        <h2>6. העברת מידע מחוץ לישראל</h2>
        <p>
          6.1. ייתכן שחלק מהספקים (כגון תשתיות ענן, אנליטיקה, מסרים) מפעילים שרתים או תתי-מעבדים
          מחוץ לישראל.
        </p>
        <p>
          6.2. החברה תנקוט אמצעים סבירים כדי לוודא העברה ואחסון ברמת הגנה מתאימה, לרבות התחייבויות
          חוזיות ואמצעי אבטחה מקובלים, בהתאם לדין.
        </p>

        <h2>7. Cookies וכלי מדידה</h2>
        <p>
          7.1. המערכת משתמשת ב-Cookies ובטכנולוגיות דומות לצרכים כגון: תפעול שוטף, אבטחה, שמירת
          העדפות, מדידה ושיפור השירות.
        </p>
        <p>
          7.2. ייתכן שהמערכת עושה שימוש בכלי אנליטיקה/מדידה של צדדים שלישיים. חלק מהכלים עשויים
          להציב Cookies וליצור מזהים סטטיסטיים.
        </p>
        <p>
          7.3. ניתן לשלוט ב-Cookies באמצעות הגדרות הדפדפן. חסימת Cookies חיוניים עלולה לפגוע בזמינות
          או באיכות השירות.
        </p>

        <h2>8. אבטחת מידע</h2>
        <p>
          8.1. החברה נוקטת אמצעי אבטחת מידע טכניים וארגוניים סבירים ומקובלים, בהתאם לסיכונים, לרבות
          בקרות גישה, ניהול הרשאות, לוגים, הצפנה ככל שרלוונטי, גיבויים, וניטור.
        </p>
        <p>
          8.2. חרף מאמצי החברה, אין אפשרות להבטיח אבטחה מוחלטת. במקרה של אירוע אבטחת מידע, החברה
          תפעל בהתאם לחובותיה לפי דין ולנהלים פנימיים.
        </p>

        <h2>9. שמירת מידע (Retention)</h2>
        <p>
          9.1. החברה תשמור מידע אישי רק כל עוד הדבר נדרש למטרות שלשמן נאסף, לצרכי מתן השירות, לצרכי
          אבטחה, לצרכי תיעוד חשבונאי/מסחרי, ולציות לדין.
        </p>
        <p>
          9.2. תקופות שמירה עשויות להשתנות לפי סוג המידע, מטרות העיבוד וחובות חוקיות (לרבות דיני
          מס/חשבונאות, התיישנות ותביעות).
        </p>

        <h2>10. זכויות עיון, תיקון ועדכון מידע</h2>
        <p>
          10.1. בהתאם לדין, ניתן לפנות לחברה בבקשה לעיין במידע אישי עליך המצוי במאגרי החברה ו/או
          לבקש תיקון/עדכון מידע שאינו נכון, שלם, ברור או מעודכן, בהתאם להוראות הדין והנהלים.
        </p>
        <p>10.2. החברה רשאית לבקש אימות זהות וסמכות (בפרט כאשר מדובר במשתמש מורשה מטעם לקוח).</p>
        <p>
          10.3. פניות בנושא פרטיות ניתן לשלוח לכתובת:
          <a href="mailto:eldad@rosman.co.il">eldad@rosman.co.il</a>.
        </p>

        <h2>11. מידע על אנשי קשר מטעם הלקוח</h2>
        <p>
          11.1. הלקוח אחראי לכך שפרטי אנשי הקשר שמסר לחברה נמסרו כדין ובסמכות, וכי אנשי קשר אלו
          מודעים לכך שפרטיהם ישמשו לניהול ותפעול הקשר העסקי והמערכת.
        </p>
        <p>
          11.2. הלקוח מתחייב לעדכן את החברה כאשר איש קשר חדל להיות מורשה/רלוונטי (למשל עקב עזיבת
          תפקיד), ולוודא ניהול הרשאות תקין.
        </p>

        <h2>12. שינויים במדיניות</h2>
        <p>
          החברה רשאית לעדכן מדיניות פרטיות זו מעת לעת. הנוסח המעודכן יפורסם במערכת ויחול ממועד
          פרסומו. המשך שימוש במערכת לאחר עדכון יהווה הסכמה למדיניות המעודכנת.
        </p>

        <h2>13. יצירת קשר</h2>
        <p>
          לשאלות, הערות או בקשות בנושא פרטיות ניתן לפנות לכתובת:
          <a href="mailto:eldad@rosman.co.il">eldad@rosman.co.il</a>.
        </p>
      </article>
    </main>

    <!-- Footer -->
    <footer class="document-footer">
      <p>© 2024 GoFood. כל הזכויות שמורות.</p>
    </footer>
  </div>
</template>

<style scoped>
.document-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--bg-primary);
}

.document-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid var(--border-color);
  padding: var(--spacing-md) var(--spacing-lg);
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 800px;
  margin: 0 auto;
}

.back-link {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  color: var(--text-primary);
  text-decoration: none;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  transition: color var(--transition-fast);
}

.back-link:hover {
  color: #d97706;
}

.logo-wrapper {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  text-decoration: none;
}

.logo-img {
  width: 32px;
  height: 32px;
  border-radius: var(--border-radius-sm);
}

.logo-text {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  color: var(--text-primary);
}

.document-main {
  flex: 1;
  padding: var(--spacing-lg);
}

.document-content {
  max-width: 800px;
  margin: 0 auto;
  background: white;
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius-lg);
  padding: var(--spacing-xl);
  line-height: 1.8;
}

.document-content h1 {
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-bold);
  color: var(--text-primary);
  margin: 0 0 var(--spacing-xl) 0;
  padding-bottom: var(--spacing-md);
  border-bottom: 2px solid #d97706;
}

.document-content h2 {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
  margin: var(--spacing-xl) 0 var(--spacing-md) 0;
}

.document-content p {
  margin: 0 0 var(--spacing-sm) 0;
  color: var(--text-secondary);
}

.document-content p.note {
  background: #fef3c7;
  border: 1px solid #f59e0b;
  border-radius: var(--border-radius-md);
  padding: var(--spacing-md);
  margin: var(--spacing-md) 0;
}

.document-content ul {
  margin: var(--spacing-sm) 0 var(--spacing-md) 0;
  padding-right: var(--spacing-xl);
}

.document-content li {
  margin-bottom: var(--spacing-xs);
  color: var(--text-secondary);
}

.document-content strong {
  color: var(--text-primary);
}

.document-content a {
  color: #d97706;
  text-decoration: none;
}

.document-content a:hover {
  text-decoration: underline;
}

.document-footer {
  text-align: center;
  padding: var(--spacing-lg);
  color: var(--text-muted);
  font-size: var(--font-size-xs);
  border-top: 1px solid var(--border-color);
}

.document-footer p {
  margin: 0;
}

@media (max-width: 768px) {
  .document-content {
    padding: var(--spacing-lg);
  }

  .document-content h1 {
    font-size: var(--font-size-xl);
  }
}
</style>
